<template>
  <nav class="navbar zul-topbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a
        role="button"
        class="navbar-burger burger zul-sidebar-burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
        @click="updateMenu(!isMenuOpen)"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>

      <span class="company-name">
        {{ user.name }}
      </span>
    </div>
    <div class="navbar-menu">
      <div class="navbar-end">
        <router-link class="exit-link" to="/logout">Sair</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import company from "../services/company";
import { formatCNPJ } from "../filters/document";

export default {
  props: {
    isMenuOpen: Boolean,
    updateMenu: Function
  },
  data() {
    return {
      user: {}
    };
  },
  async mounted() {
    if (this.$auth.ready()) {
      try {
        this.user = await company.get();
        this.user.document = formatCNPJ(this.user.document);
      } catch (err) {
        console.error(err);
        this.user = {};
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
